import LytefloLogo from "@lyteflo/assets/logos/lyteflo.svg?react";

export const LytefloLoadingScreen = () => {
  return (
    <div className="lf-h-[100svh] lf-flex lf-items-center lf-justify-center lf-bg-color">
      <div className="lf-flex lf-flex-col lf-items-center lf-justify-center lf-w-40 md:lf-w-60 lg:lf-w-80">
        <LytefloLogo className="lf-w-full lf-animate-pulse" />
      </div>
    </div>
  );
};
